import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

export function ImpersonationBar() {
  const [returnData, setReturnData] = useState<{
    access_token: string;
    refresh_token: string;
    admin_email: string;
  } | null>(null);

  useEffect(() => {
    const stored = sessionStorage.getItem("admin_impersonate_return");
    if (!stored) return;
    try {
      const parsed = JSON.parse(stored);
      // Auto-clear if the current user IS the admin (stale data)
      supabase.auth.getUser().then(({ data }) => {
        if (data?.user?.email === parsed.admin_email) {
          sessionStorage.removeItem("admin_impersonate_return");
          setReturnData(null);
        } else {
          setReturnData(parsed);
        }
      });
    } catch {
      sessionStorage.removeItem("admin_impersonate_return");
    }
  }, []);

  if (!returnData) return null;

  const handleReturn = async () => {
    try {
      await supabase.auth.setSession({
        access_token: returnData.access_token,
        refresh_token: returnData.refresh_token,
      });
      sessionStorage.removeItem("admin_impersonate_return");
      window.location.href = "/admin/users";
    } catch {
      sessionStorage.removeItem("admin_impersonate_return");
      window.location.href = "/auth";
    }
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-amber-500 text-amber-950 px-4 py-1.5 flex items-center justify-center gap-3 text-sm font-medium shadow-md">
      <span>Viewing as another user — original admin: {returnData.admin_email}</span>
      <Button
        size="sm"
        variant="outline"
        className="h-6 px-2 text-xs bg-amber-600/20 border-amber-700/30 text-amber-950 hover:bg-amber-600/40"
        onClick={handleReturn}
      >
        <ArrowLeft className="w-3 h-3 mr-1" />
        Return to Admin
      </Button>
    </div>
  );
}
